import script from "./ActiveLearning.vue?vue&type=script&lang=ts&setup=true"
export * from "./ActiveLearning.vue?vue&type=script&lang=ts&setup=true"

import "./ActiveLearning.vue?vue&type=style&index=0&id=370dfc18&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-370dfc18"]])

export default __exports__